const AccountApiPaths = {
  GetUserProfileInfo: 'registration_issurance_visit/api/Expert/GetUserProfileInfo',
  AssignSignature: 'registration_issurance_visit/api/Expert/AssignSignatureToExpert',
}

export default AccountApiPaths
